module.exports = __webpack_public_path__ + "static/img/icon-metodologia-1.7836f87e.svg";